module.exports = __webpack_public_path__ + "static/media/gs-banner-produtos.a43fdfb0.jpg";